<template>
  <div class="table-crm">
    <b-table
      class="table table-bordered w-100 report-table"
      hover
      responsive
      :items="listData"
      :fields="fields"
    >
      <template #cell(mtd)="data">
        <div class="text-right">
          {{ getDisplayData(data.item.name, data.item.mtd) }}
        </div>
      </template>
      <template #cell(mtdLastYear)="data">
        <div class="text-right">
          {{ getDisplayData(data.item.name, data.item.mtdLastYear) }}
        </div>
      </template>
      <template #cell(ytd)="data">
        <div class="text-right">
          {{ getDisplayData(data.item.name, data.item.ytd) }}
        </div>
      </template>
      <template #cell(ytdLastYear)="data">
        <div class="text-right">
          {{ getDisplayData(data.item.name, data.item.ytdLastYear) }}
        </div>
      </template>
      <template #cell(12monthRolling)="data">
        <div class="text-right">
          {{ getDisplayData(data.item.name, data.item["12monthRolling"]) }}
        </div>
      </template>
      <template #cell(12monthRollingLastYear)="data">
        <div class="text-right">
          {{
            getDisplayData(data.item.name, data.item["12monthRollingLastYear"])
          }}
        </div>
      </template>
      <template #cell(mtdPercentChanged)="data">
        <div class="text-right">
          {{ percentageFormat(data.item.mtdPercentChanged) }}
        </div>
      </template>
      <template #cell(ytdPercentChanged)="data">
        <div class="text-right">
          {{ percentageFormat(data.item.ytdPercentChanged) }}
        </div>
      </template>
      <template #cell(12monthRollingPercentChanged)="data">
        <div class="text-right">
          {{ percentageFormat(data.item["12monthRollingPercentChanged"]) }}
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import downloadExcel from "@/views/Reports/downloadExcel";

export default {
  name: "MetricTable",
  props: {
    fields: {
      type: Array,
      default: () => [],
    },
    listData: {
      type: Array,
      default: () => [],
    },
    isRetentionMetrics: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    percentageFormat(value) {
      if (value) {
        return downloadExcel.percentageFormat(value);
      } else {
        return "";
      }
    },
    addPercentage(value) {
      return value + "%";
    },
    isAddedPercentage(value) {
      return value.slice(-4) === "Rate" && this.isRetentionMetrics === true;
    },
    getDisplayData(itemName, itemField) {
      return this.isAddedPercentage(itemName)
        ? this.addPercentage(itemField.toLocaleString())
        : itemField.toLocaleString();
    },
  },
};
</script>
